<template>
  <div class="rightWrap">
    <div class="rightMain">
      <div class="imgShowWrap">
        <Slide ref="slide" @change="showBig"/>
      </div>
      <div class="rightBox" v-if="canvasType">
        <!-- <div class="replaceImgBtn" v-if="canvasType === 'img'">
          替换图片
        </div>-->
        <div class="operateBar">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ $t('design.heightFill') }}</span>
            </template>
            <div class="operateItem htcIcon" @click="moveActive(22)"></div>
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ $t('design.widthFill') }}</span>
            </template>
            <div class="operateItem wtcIcon" @click="moveActive(21)"></div>
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ $t('design.fill') }}</span>
            </template>
            <div class="operateItem tcIcon" @click="moveActive(1)"></div>
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ $t('design.adapt') }}</span>
            </template>
            <div class="operateItem syIcon" @click="moveActive(2)"></div>
          </a-tooltip>
        </div>
        <div class="operateBar">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ $t('design.rotate') }}45°</span>
            </template>
            <div class="operateItem xzIcon" @click="rotateFn(45)"></div>
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ $t('design.center') }}</span>
            </template>
            <div class="operateItem jzIcon" @click="moveActive(10)"></div>
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ $t('design.flipHorizontally') }}</span>
            </template>
            <div class="operateItem xfzIcon" @click="moveActive(5)"></div>
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ $t('design.flipVertically') }}</span>
            </template>
            <div class="operateItem yfzIcon" @click="moveActive(6)"></div>
          </a-tooltip>
        </div>
        <div class="sliderWrap operateBar">
          <span>{{ $t('design.rotate') }}</span>
          <span>
            <a-slider
              style="width: 120px"
              v-model="sliderValue"
              @change="sliderValueFn"
              :min="-180"
              :max="180"
            />
          </span>
          <span class="inputBox">
            <div class="caretBox">
              <a-icon class="caretBtn up" type="caret-up" @click="setInputValue(1)"/>
              <a-icon class="caretBtn down" type="caret-down" @click="setInputValue(-1)"/>
            </div>
            <a-input
              style="width: 80px"
              v-model="inputValue"
              :min="-180"
              :max="180"
              @change="inputValueFn"
            />
          </span>
        </div>
        <div class="operateBar">
          <a-dropdown
            :getPopupContainer="
              triggerNode => {
                return triggerNode.parentNode || document.body
              }
            "
          >
            <div slot="overlay">
              <div class="overlayWrap">
                <div class="materialItem">
                  <div class="materialBg" @click="materialVisionMethod(-1)">
                    <a-icon type="stop" style="margin-right: 4px;"/>Recovery
                  </div>
                </div>
                <div class="materialItem">
                  <div class="materialBg" @click="materialVisionMethod(4)">
                    <img src="@/assets/design/right_18.png">
                    {{ $t('design.cutHead') }}
                  </div>
                </div>
                <div class="materialItem">
                  <div class="materialBg" @click="materialVisionMethod(1)">
                    <img src="@/assets/design/right_19.png">
                    {{ $t('design.cutPicture') }}
                  </div>
                </div>
                <div class="materialItem">
                  <div class="materialBg" @click="materialVisionMethod(2)">
                    <img src="@/assets/design/right_20.png">
                    {{ $t('design.clearly') }}
                  </div>
                </div>
                <div class="materialItem">
                  <div class="materialBg" @click="materialVisionMethod(3)">
                    <img src="@/assets/design/right_21.png">
                    {{ $t('design.crop') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="operateItem hover w130">
              <div class="txIcon iconBox"></div>
              {{ $t('design.image') }}
            </div>
          </a-dropdown>
          <a-popover
            placement="bottomLeft"
            :trigger="['hover']"
            overlayClassName="groupOverlayWrap"
            :getPopupContainer="() => document.getElementById('groupStylesId')"
          >
            <template slot="content">
              <div
                v-for="(value, index) in groupStyles"
                :key="index"
                class="groupList"
                :class="{ on: activeGroupInfo.type === value.type }"
                @click="createGroupImgEntry(value.type)"
              >
                <img :src="require(`@/assets/design/${value.imgName}.png`)" height="35">
                <p
                  style="padding: 0; margin: 0; font-weight: bold; font-size: 10px"
                >{{ value.name }}</p>
              </div>
              <div v-if="activeGroupInfo.type !== 0">
                <a-row>
                  <a-col :span="12" style="line-height: 36px;">
                    <span>{{ $t('design.xSpacing') }}</span>
                  </a-col>
                  <a-col :span="12">
                    <a-slider
                      :min="0"
                      :max="20"
                      :value="activeGroupInfo.paddingX"
                      @change="e => setGroupPaddingX({ activeDesign, data: e })"
                      @afterChange="createGroupImgEntry(activeGroupInfo.type)"
                    />
                  </a-col>
                </a-row>
                <a-row style="margin-top: 10px">
                  <a-col :span="12" style="line-height: 36px;">
                    <span>{{ $t('design.ySpacing') }}</span>
                  </a-col>
                  <a-col :span="12">
                    <a-slider
                      :min="0"
                      :max="20"
                      :value="activeGroupInfo.paddingY"
                      @change="e => setGroupPaddingY({ activeDesign, data: e })"
                      @afterChange="createGroupImgEntry(activeGroupInfo.type)"
                    />
                  </a-col>
                </a-row>
              </div>
            </template>
            <div class="operateItem hover w130" id="groupStylesId">
              <div class="ppIcon iconBox"></div>
              {{ $t('design.tile') }}
            </div>
          </a-popover>
        </div>
        <div class="operateBar">
          <a-popover
            placement="bottomLeft"
            :trigger="['hover']"
            overlayClassName="groupOverlayWrap"
            :getPopupContainer="() => document.getElementById('imgStylesId')"
          >
            <template slot="content">
              <div class="imgStylesItemBox">
                <template v-for="(value, index) in designStyleData">
                  <template v-if="value.style === 0">
                    <div class="imgStylesItem" :key="index">
                      <div class="imgStylesItemBg" @click="changeImgStyleMethod(0)">
                        <!-- <div class="noSty" @click="changeImgStyleMethod(0)">
                          <a-icon class="stopIcon" type="stop" />
                        </div>-->
                        <img :src="value.url" height="40">
                      </div>
                    </div>
                  </template>
                  <template v-else-if="value.children && value.children.length">
                    <a-popover
                      :key="index"
                      placement="bottom"
                      :trigger="['hover']"
                      overlayClassName="groupOverlayWrap"
                      :getPopupContainer="() => document.getElementById(`cartoonId_${index}`)"
                    >
                      <template slot="content">
                        <div class="imgStylesItemBox">
                          <div class="imgStylesItem" v-for="(item, i) in value.children" :key="i">
                            <div
                              class="imgStylesItemBg ctHover"
                              @click="changeImgStyleMethod(item.style)"
                            >
                              <img :src="item.url" height="40">
                              <p
                                style="padding: 0; font-weight: bold; font-size: 10px"
                              >{{ item.name }}</p>
                            </div>
                          </div>
                        </div>
                      </template>
                      <div class="imgStylesItem" :id="`cartoonId_${index}`" v-if="value.children">
                        <div class="imgStylesItemBg hover">
                          <img :src="value.url" height="40">
                          <p style="padding: 0; font-weight: bold; font-size: 10px">{{ value.name }}</p>
                        </div>
                      </div>
                    </a-popover>
                  </template>
                  <template v-else>
                    <div class="imgStylesItem" :key="index">
                      <div class="imgStylesItemBg hover" @click="changeImgStyleMethod(0, 3)">
                        <img :src="value.url" height="40">
                        <p style="padding: 0; font-weight: bold; font-size: 10px">{{ value.name }}</p>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
            </template>
            <div class="operateItem hover w130" id="imgStylesId">
              <div class="fgIcon iconBox"></div>
              {{ $t('design.style') }}
            </div>
          </a-popover>
          <a-dropdown
            :getPopupContainer="
              triggerNode => {
                return triggerNode.parentNode || document.body
              }
            "
          >
            <div slot="overlay">
              <div class="overlayWrap w160">
                <div class="maskItem" @click="maskChange('')">
                  <a-icon type="stop" style="font-size: 36px;"/>
                </div>
                <div
                  class="maskItem"
                  @click="maskChange(value)"
                  v-for="(value, index) in masks"
                  :key="index"
                >
                  <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg">
                    <svg viewBox="-15 -15 330 330">
                      <path fill="#333" stroke="transparent" stroke-width="10" :d="value"></path>
                    </svg>
                  </svg>
                </div>
              </div>
            </div>
            <div class="operateItem hover w130">
              <div class="zzIcon iconBox"></div>
              {{ $t('design.shade') }}
            </div>
          </a-dropdown>
        </div>
        <div class="operateBar bg">
          <a-tooltip
            placement="top"
            :getPopupContainer="
              triggerNode => {
                return triggerNode.parentNode || document.body
              }
            "
          >
            <template slot="title">
              <span>
                Select the design element, hover the mouse over the canvas, and slide the mouse wheel to control the
                enlargement and reduction of the element
              </span>
            </template>
            <div class="iconBox sfIcon"></div>
          </a-tooltip>

          <a-tooltip
            placement="top"
            :getPopupContainer="
              triggerNode => {
                return triggerNode.parentNode || document.body
              }
            "
          >
            <template slot="title">
              <span>{{ $t('generic.copy') }}</span>
            </template>
            <div class="iconBox fzIcon" @click="copyLayer"></div>
          </a-tooltip>
          <a-tooltip
            placement="top"
            :getPopupContainer="
              triggerNode => {
                return triggerNode.parentNode || document.body
              }
            "
          >
            <template slot="title">
              <span>{{ $t('design.moveLayerUp') }}</span>
            </template>
            <div class="iconBox upIcon" @click="moveActive(11)"></div>
          </a-tooltip>
          <a-tooltip
            placement="top"
            :getPopupContainer="
              triggerNode => {
                return triggerNode.parentNode || document.body
              }
            "
          >
            <template slot="title">
              <span>{{ $t('design.moveLayerDown') }}</span>
            </template>
            <div class="iconBox downIcon" @click="moveActive(12)"></div>
          </a-tooltip>
          <a-tooltip
            placement="top"
            :getPopupContainer="
              triggerNode => {
                return triggerNode.parentNode || document.body
              }
            "
          >
            <template slot="title">
              <span>{{ $t('design.deleteLayer') }}</span>
            </template>
            <div class="iconBox deleteIcon" @click="delLayer"></div>
          </a-tooltip>
        </div>
      </div>
      <div class="rightBox" v-else>
        <p class="nullP">{{ $t('design.editElementTips') }}</p>
      </div>
    </div>
    <a-modal
      :visible="visible"
      @cancel="
        () => {
          visible = false
        }
      "
      @ok="getCanvasImg"
      :getContainer="() => document.getElementById('app')"
      width="1048px"
      title="Picture clipping"
      :destroyOnClose="true"
    >
      <ClipImg :src="src" ref="clipImg"/>
    </a-modal>
    <NameEdit ref="nameEdit"></NameEdit>
    <JoinCar ref="joinCar" @ok="showConfirmFn"></JoinCar>
    <a-modal
      title="Choose your store"
      :visible="visible_publish"
      @cancel="visible_publish = false"
      destroyOnClose
      :footer="null"
    >
      <StoreListContent ref="storeListContent"/>
      <div v-if="storeList.length > 0" style="text-align: right">
        <a-button type="primary" @click="ok">Confirm</a-button>
      </div>
    </a-modal>
    <a-modal
      :visible="confirm_visible > 0"
      @cancel="confirm_visible = 0"
      destroyOnClose
      :cancelText="confirmCancelText"
      okText="View"
      width="400px"
      @ok="confirm_visible === 1 ? $router.push('/personal_center/productTemplate') : $router.push('/cart')"
    >
      <div style="display: flex">
        <a-icon
          type="check-circle"
          theme="filled"
          style="font-size: 40px; color: rgb(136, 208, 104)"
        />
        <div style="margin-left: 20px;">
          <div>Saved successfully</div>
          <div>Leave or view now</div>
        </div>
      </div>
    </a-modal>
    <Brand ref="brand" @change="brandBachSave"></Brand>
    <a-modal
      wrapClassName="successModal"
      :closable="false"
      destroyOnClose
      :visible="successNum > 0"
      @cancel="
        () => {
          successNum = 0
        }
      "
      width="560px"
      :footer="null"
    >
      <div class="successWrap">
        <img class="img" src="@/assets/brand/2.png">
        <div class="title">Saved Successfully!</div>
        <div class="tip">Leave Or View Now</div>
        <div class="btnWrap">
          <a @click="successNum = 0">Cancel ({{ successNum }})</a>
          <a class="save" href="/personal_center/brand/2">View</a>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import NameEdit from './nameEdit.vue'
import JoinCar from '@/views/design/components/joinCar.vue'
import { mapState, mapGetters, mapMutations } from 'vuex'
import Slide from './swiper/swiper.vue'
import SlideTop from './swiper/swiperTop.vue'
// eslint-disable-next-line no-unused-vars
import {
  saveDesign,
  getUserHotKeys,
  setUserHotKeys,
  getMaskLayer,
  handleMaterialVision,
  getMaterialVision
} from '@/api/design'
// getProductDesignInfo
import { setMasterImgColor } from '@/api/productLibrary/index'
// import { addCartItem } from '@/api/cart'
import { getActualSizeTip, saveHistory } from '@/utils/util'
import { keyCodeData } from '@/utils/const'
import * as cc from 'my-design-canvas/desf4fc'
import ClipImg from './clipImg'
import StoreListContent from '@/views/productTemplate/components/storeListContent'
import { getUserStore } from '@/api/order'
import Brand from './brand.vue'
import { addBrand } from '@/api/brand'

// eslint-disable-next-line no-unused-vars
export default {
  name: 'RightWrap',
  data() {
    return {
      successNum: 0,
      designStyleData: [],
      styleImg: -1,
      src: '',
      visible: false,
      recordTrue: false,
      left: 0,
      inputValue: 0,
      sliderValue: 0,
      visiable: false,
      explain: false,
      isEdit: false,
      isTrue: false,
      isBlack: false,
      enName: '',
      currKey: {},
      imgList: [],
      searchCondition: {
        total: 1,
        per_page: 6,
        page: 1
      },
      groupKey: '',
      masks: [],
      groupStyleClose: false,
      groupStyles: [
        { name: 'no-repeat', type: 0, imgName: '不平铺' },
        { name: 'Foundation tiling', type: 1, imgName: '基础平铺' },
        { name: 'Longitudinal interleaving', type: 3, imgName: '纵向交错' },
        { name: 'Transverse interleaving', type: 2, imgName: '横向交错' },
        { name: 'Mirror tiling', type: 4, imgName: '镜像平铺' },
        { name: 'Random tiling', type: 5, imgName: '随机平铺' }
      ],
      storeList: [],
      visible_publish: false,
      confirm_visible: 0,
      countNum: 0
    }
  },
  props: ['configData'],
  computed: {
    ...mapState({
      info: state => state.user.info,
      showImgList: state => state.design.showImgList,
      fabricList: state => state.design.fabricList,
      activeDesign: state => state.design.activeDesign,
      basic_product_id: state => state.design.basic_product_id,
      initialColor: state => state.design.initialColor,
      initialSize: state => state.design.initialSize,
      printImgInfo: state => state.design.printImgInfo,
      priceData: state => state.design.priceData,
      hotKeys: state => state.design.hotKeys,
      tipLevels: state => state.design.tipLevels,
      print_areas: state => state.design.print_areas,
      originalImgList: state => state.design.originalImgList
    }),
    ...mapGetters([
      'designColors',
      'designSizes',
      'show_images_design',
      'activeFabric',
      'tipLevel',
      'activePrintAreas',
      'activeGroupInfo',
      'canvasType'
    ]),
    confirmCancelText() {
      return 'Cancel (' + this.countNum + 's)'
    }
  },
  watch: {
    successNum(value) {
      if (value > 0) {
        setTimeout(() => {
          this.successNum--
        }, 1000)
      } else {
        this.successNum = 0
      }
    },
    countNum(value) {
      if (value > 0) {
        setTimeout(() => {
          this.countNum--
        }, 1000)
      }
    }
  },
  components: { Slide, SlideTop, NameEdit, JoinCar, ClipImg, StoreListContent, Brand },
  methods: {
    ...mapMutations({
      setColor: 'SET_INITIAL_COLOR',
      setSize: 'SET_INITIAL_SIZE',
      setRandom: 'SET_RANDOM',
      resetFabricList: 'RESET_FABRIC_LIST',
      setSyncOtherSide: 'SET_SYNC_OTHER_SIDE',
      setRelateInfo: 'SET_RELATE_INFO',
      setVisible: 'SET_VISIBLE',
      setPrice: 'SET_PRICE',
      setHotKeys: 'SET_HOTKEYS',
      setCopyProductId: 'SET_COPY_PRODUCT_ID',
      SET_SLIDER_INDEX: 'SET_SLIDER_INDEX',
      SET_ACTIVE_DESIGN: 'SET_ACTIVE_DESIGN',
      SET_ACTIVE_FABRIC_LIST_GRUOP: 'SET_ACTIVE_FABRIC_LIST_GRUOP',
      SET_INITIAL_COLOR: 'SET_INITIAL_COLOR',
      SET_PRINT_AREAS: 'SET_PRINT_AREAS',
      SET_PRINT_IMG_INFO: 'SET_PRINT_IMG_INFO',
      SET_ALL_BOTTOM_IMAGES_TEMPLATE: 'SET_ALL_BOTTOM_IMAGES_TEMPLATE',
      SET_ALL_SHOW_IMAGES_DESIGN: 'SET_ALL_SHOW_IMAGES_DESIGN',
      SET_INITIAL_SIZE: 'SET_INITIAL_SIZE',
      SET_INIT_TIP_LEVEL: 'SET_INIT_TIP_LEVEL',
      SET_INITIAL_GROUP_INFO: 'SET_INITIAL_GROUP_INFO',
      SET_BASIC_PRODUCT_ID: 'SET_BASIC_PRODUCT_ID',
      setPx: 'SET_ONE_PX_TO_REAL_WIDTH',
      setTipLevel: 'SET_TIP_LEVEL',
      setGroupCode: 'SET_GROUP_CODE',
      setCanvasType: 'SET_CANVAS_TYPE',
      // 平铺数据
      setGroupType: 'SET_GROUP_TYPE',
      setGroupPaddingX: 'SET_GROUP_PADDING_X',
      setGroupPaddingY: 'SET_GROUP_PADDING_Y',
      setBackLoading: 'SET_BACK_LOADING'
    }),
    changeImgStyleMethod(index, n) {
      // 风格
      const t = this.activeFabric.getActiveObject()
      if (!t) {
        this.$message.warning('Please select a picture and try again!')
        return
      }
      if (t && t.type !== 'image') {
        this.$message.warning('Please select a picture and try again!')
        return
      }
      if (n === 3) {
        // 刺绣
        this.embroideryFn(t)
        return
      }
      t &&
        (() => {
          handleMaterialVision({
            material_id: t.material_id || t.material_code,
            type: 1,
            style_type: index,
            oss_file_id: t.vision_oss_file_id ? t.vision_oss_file_id : t.oss_file_id
          }).then(res => {
            t.setSrc(
              res.data.vision_oss_file_url,
              img => {
                img.set({
                  style: index,
                  vision_oss_file_id: res.data.vision_oss_file_id,
                  // 解决clippath 后setSrc失效问题
                  dirty: true
                })
                this.styleImg = index
                if (this.activeGroupInfo.code === t.time) {
                  this.createGroupImgEntry(this.activeGroupInfo.type)
                } else {
                  const objects = this.activeFabric.getObjects()
                  const group = objects.find(item => item.type === 'group')
                  if (group && group.time === t.time) {
                    this.createGroupImgEntry(group.groupType)
                  } else {
                    this.activeFabric.renderAll()
                    this.setRandom()
                    saveHistory()
                  }
                }
              },
              { crossOrigin: 'annonymous' }
            )
          })
        })()
    },
    embroideryFn(t) {
      t &&
        (() => {
          handleMaterialVision({
            material_id: t.material_id || t.material_code,
            type: 3,
            oss_file_id: t.vision_oss_file_id ? t.vision_oss_file_id : t.oss_file_id
          }).then(res => {
            t.setSrc(
              res.data.vision_oss_file_url,
              img => {
                img.set({
                  vision_oss_file_id: res.data.vision_oss_file_id,
                  // 解决clippath 后setSrc失效问题
                  dirty: true
                })
                if (this.activeGroupInfo.code === t.time) {
                  this.createGroupImgEntry(this.activeGroupInfo.type)
                } else {
                  const objects = this.activeFabric.getObjects()
                  const group = objects.find(item => item.type === 'group')
                  if (group && group.time === t.time) {
                    this.createGroupImgEntry(group.groupType)
                  } else {
                    this.activeFabric.renderAll()
                    this.setRandom()
                    saveHistory()
                  }
                }
              },
              { crossOrigin: 'annonymous' }
            )
          })
        })()
    },
    materialVisionMethod(type) {
      const t = this.activeFabric.getActiveObject()
      console.log('t====', t)
      // if (t.vision_type) {
      //   this.$message.error('该元素已执行过图形操作,无法多次执行!')
      //   return
      // }
      if ((t && t.type !== 'image') || !t) {
        this.$message.warning('Please select a picture and try again!')
        return
      }
      if (type === 3) {
        if (!t || t.type !== 'image') {
          this.$message.error('No material selected')
          return
        }
        this.visible = true
        this.src = t.getSrc()
        return
      }
      if (type === -1) {
        console.log(t)
        console.log(this.originalImgList)
        if (!t || t.type !== 'image') {
          this.$message.error('No material selected')
          return
        }
        let oldImg = {}
        this.originalImgList.forEach(item => {
          if (item.id === t.material_id) {
            oldImg = item
          }
        })
        t.setSrc(
          oldImg.src,
          img => {
            img.set({
              vision_type: -1,
              vision_oss_file_id: oldImg.design_oss_file_id,
              dirty: false
            })

            if (t && this.activeGroupInfo.code === t.time) {
              this.createGroupImgEntry(this.activeGroupInfo.type)
            } else {
              const objects = this.activeFabric.getObjects()
              const group = objects.find(item => item.type === 'group')
              if (t && group && group.time === t.time) {
                this.createGroupImgEntry(group.groupType)
              } else {
                this.activeFabric.renderAll()
                this.setRandom()
                saveHistory()
              }
            }
          },
          { crossOrigin: 'annonymous' }
        )
        return
      }
      t
        ? handleMaterialVision({
            material_id: t.material_id || t.material_code,
            type: 2,
            vision_type: type,
            oss_file_id: t.vision_oss_file_id ? t.vision_oss_file_id : t.oss_file_id
          }).then(res => {
            t.setSrc(
              res.data.vision_oss_file_url,
              img => {
                img.set({
                  vision_type: type,
                  vision_oss_file_id: res.data.vision_oss_file_id,
                  dirty: true
                })

                if (t && this.activeGroupInfo.code === t.time) {
                  this.createGroupImgEntry(this.activeGroupInfo.type)
                } else {
                  const objects = this.activeFabric.getObjects()
                  const group = objects.find(item => item.type === 'group')
                  if (t && group && group.time === t.time) {
                    this.createGroupImgEntry(group.groupType)
                  } else {
                    this.activeFabric.renderAll()
                    this.setRandom()
                    saveHistory()
                  }
                }
              },
              { crossOrigin: 'annonymous' }
            )
          })
        : this.$message.error('No material selected')
    },
    getCanvasImg() {
      const clipImg = this.$refs.clipImg
      const t = this.activeFabric.getActiveObject()
      const { cropData } = clipImg
      handleMaterialVision({
        material_id: t.material_id || t.material_code,
        type: 2,
        oss_file_id: t.vision_oss_file_id ? t.vision_oss_file_id : t.oss_file_id,
        vision_type: 3,
        ...cropData
      }).then(res => {
        t.setSrc(
          res.data.vision_oss_file_url,
          img => {
            img.set({
              vision_type: 3,
              vision_oss_file_id: res.data.vision_oss_file_id,
              dirty: true,
              uuid: res.data.uuid
            })
            if (t && this.activeGroupInfo.code === t.time) {
              this.createGroupImgEntry(this.activeGroupInfo.type)
            } else {
              const objects = this.activeFabric.getObjects()
              const group = objects.find(item => item.type === 'group')
              if (t && group && group.time === t.time) {
                this.createGroupImgEntry(group.groupType)
              } else {
                this.activeFabric.renderAll()
                this.setRandom()
                saveHistory()
              }
            }
            this.visible = false
          },
          { crossOrigin: 'annonymous' }
        )
      })
    },
    maskChange(pathString) {
      const t = this.activeFabric.getActiveObject()
      if (!t || t.type !== 'image') {
        this.$message.error('Please select a picture and try again')
        return
      }
      const { height, width } = t
      const path = new cc.Path(pathString, {
        originX: 'center',
        originY: 'center',
        left: 0,
        top: 0
      })
      console.log('path====555', path)
      const scaleX = width / path.width
      const scaleY = height / path.height
      path.scale(scaleX >= scaleY ? scaleY : scaleX)
      t &&
        t.set({
          clipPath: pathString ? path : null
        })
      if (t && this.activeGroupInfo.code === t.time) {
        this.createGroupImgEntry(this.activeGroupInfo.type)
      } else {
        const objects = this.activeFabric.getObjects()
        const group = objects.find(item => item.type === 'group')
        if (t && group && group.time === t.time) {
          this.createGroupImgEntry(group.groupType)
        }
      }
      this.activeFabric.renderAll()
      this.setRandom()
      saveHistory()
    },
    createGroupImgEntry(type, obj) {
      let t = obj === undefined ? this.activeFabric.getActiveObject() : obj
      type = obj === undefined ? type : obj.groupType
      console.log('t====22222', t)
      if (t && t.type !== 'image') {
        this.$message.warning('Please select a picture and try again!')
        return
      }
      if (t) {
        if (t.type === 'activeSelection') {
          t = t.toGroup()
          t.set({
            originX: 'center',
            originY: 'center',
            time: new Date().getTime(),
            removed: true,
            centeredScaling: true
          }).setCoords()
        }
      } else {
        // this.$message.warning('请至少选中一个对象!')
        this.$message.warning('Please select a picture and try again!')
        return
      }
      this.setGroupType({ activeDesign: this.activeDesign, data: type })

      this.removeGroup()
      if (type !== 0) {
        t.set('paddingX', this.activeGroupInfo.paddingX)
        t.set('paddingY', this.activeGroupInfo.paddingY)
        t.set('groupType', this.activeGroupInfo.type)
        console.log(this.activeGroupInfo.paddingX)
        this.setGroupCode({ activeDesign: this.activeDesign, data: t.time })
        this.setBackLoading(true)
        t && this.createGroupImgMain(t, type)
      } else {
        this.setGroupCode({ activeDesign: this.activeDesign, data: '' })
        this.activeFabric.renderAll()
      }
    },
    async createGroupImgMain(t, type) {
      const group = new cc.Group([], {
        height: 2000,
        width: 2000,
        left: t.left,
        top: t.top,
        angle: t.angle,
        originX: 'center',
        originY: 'center',
        selectable: false,
        material_code: t.material_code,
        src: t.src,
        objectCaching: false,
        style: t.style,
        uuid: t.uuid,
        time: t.time,
        groupType: type,
        vision_oss_file_id: t.vision_oss_file_id || '',
        vision_type: t.vision_type
      })

      const realHeight = t.getScaledHeight()
      const realWidth = t.getScaledWidth()

      const scaleX = t.scaleX
      const scaleY = t.scaleY
      let numX = 0
      let numY = 0
      const time = type === 5 ? 2 : 1
      if (t.left > 275) {
        numX = Math.ceil(t.left / realWidth) * time
      } else {
        numX = Math.ceil((550 - t.left) / realWidth) * time
      }

      if (t.top > 275) {
        numY = Math.ceil(t.top / realHeight) * time
      } else {
        numY = Math.ceil((550 - t.top) / realHeight) * time
      }
      console.log('numX=====', numX)
      console.log('numY=====', numY)
      for (let i = 0; i <= numX; i++) {
        for (let j = 0; j <= numY; j++) {
          if (i === 0 && j === 0) {
            continue
          }
          if (i === 0) {
            await this.createImgItem(i, -j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
            await this.createImgItem(i, j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
          } else if (j === 0) {
            await this.createImgItem(-i, j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
            await this.createImgItem(i, j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
          } else {
            await this.createImgItem(i, j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
            await this.createImgItem(-i, j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
            await this.createImgItem(i, -j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
            await this.createImgItem(-i, -j, type, 0, 0, realHeight, realWidth, scaleX, scaleY, t, group)
          }
        }
      }
      const objects = this.activeFabric.getObjects()
      const index = objects.findIndex(item => item.time === t.time)
      this.activeFabric.add(group)
      // group.sendToBack()
      for (let i = 0; i < objects.length - index; i++) {
        group.sendBackwards()
      }
      setTimeout(() => {
        this.setBackLoading(false)
      }, 1000)
      this.activeFabric.renderAll()
      this.setRandom()
      saveHistory()
    },
    createImgItem(i, j, type, paddingX, paddingY, realHeight, realWidth, scaleX, scaleY, imgItem, group) {
      const _this = this
      let crossX = 0
      let crossY = 0
      if (type === 2) {
        crossX = Math.abs(j) % 2 === 0 ? 0 : realWidth / 2
      }
      if (type === 3) {
        crossY = Math.abs(i) % 2 === 0 ? 0 : realHeight / 2
      }
      if (type === 4) {
        scaleX = Math.abs(i) % 2 === 0 ? scaleX : -scaleX
        scaleY = Math.abs(j) % 2 === 0 ? scaleY : -scaleY
      }
      let rand = 0
      let randScale = 1
      if (type === 5) {
        rand = Math.random() < 0.5 ? -1 : 1
        randScale = Math.random() * 0.5 + 0.5
      }

      // eslint-disable-next-line promise/param-names
      return new Promise(res => {
        imgItem.clone(img => {
          img.set({
            left: i * (realWidth / (type === 5 ? 2 : 1) - 0.32 + (_this.activeGroupInfo.paddingX || 0)) + crossX,
            top: j * (realHeight / (type === 5 ? 2 : 1) - 0.32 + (_this.activeGroupInfo.paddingY || 0)) + crossY,
            angle: rand * 30 * randScale,
            scaleX: scaleX * randScale,
            scaleY: scaleY * randScale,
            material_code: imgItem.material_code
          })

          group.add(img)
          res()
        })
      })
    },
    removeGroup() {
      const objects = this.activeFabric.getObjects()
      objects.map(item => {
        if (item.type === 'group' && !item.removed) {
          this.activeFabric.remove(item)
        }
      })
    },
    syncOtherSideImage(index, callBack) {
      const otherFabric = this.fabricList.filter(item => item.view_id !== this.activeDesign)
      otherFabric.length &&
        otherFabric.map(item => {
          callBack(item.canObj.item(index), item.view_id, item)
        })
    },
    moveActive(index) {
      // const that = this
      const t = this.activeFabric.getActiveObject()
      const objects = this.activeFabric.getObjects()
      const group = objects.find(item => item.type === 'group')
      if (!t) {
        return
      }
      const i = this.activeFabric.getObjects().indexOf(t)
      const { syncOtherSide } = this
      switch (index) {
        case 1:
          t &&
            (() => {
              this.scaleWithAngleFix(this.activeDesign, t)
              const tipLevel = getActualSizeTip(
                t.height,
                t.width,
                t.scaleX,
                t.scaleY,
                this.onePxToRealWidth,
                this.printImgInfo.dpi,
                t.pxH,
                t.pxW
              )
              this.setTipLevel(tipLevel)
              return true
            })()
          break
        case 2:
          t &&
            (() => {
              const scale = this.scaleSingleWithAngleFix(this.activeDesign, t)
              console.log(scale, 'scale')
              t.scale(scale)
              t.set('left', 275).setCoords()
              t.set('top', 275).setCoords()
              const tipLevel = getActualSizeTip(
                t.height,
                t.width,
                scale,
                scale,
                this.onePxToRealWidth,
                this.printImgInfo.dpi,
                t.pxH,
                t.pxW
              )
              this.setTipLevel(tipLevel)
              return true
            })()
          break
        case 5:
          t &&
            t.set({
              scaleX: -t.scaleX
            })
          if (t && group && group.time === t.time) {
            this.createGroupImgEntry(t.groupType, t)
          }
          break
        case 6:
          t &&
            t.set({
              scaleY: -t.scaleY
            })
          if (t && group && group.time === t.time) {
            this.createGroupImgEntry(t.groupType, t)
          }
          break
        case 10:
          t.set('left', 275).setCoords()
          t.set('top', 275).setCoords()
          if (t && group && group.time === t.time) {
            this.createGroupImgEntry(t.groupType, t)
          }
          break
        case 11:
          t &&
            t.bringForward() &&
            syncOtherSide &&
            this.syncOtherSideImage(i, t => {
              t && t.bringForward()
            }) // 向上一层
          if (t && group) {
            const groupObj = objects.find(item => item.type === 'group')
            const groupMap = objects.find(item => groupObj.time === item.time && item.type !== 'group')
            const groupIndex = objects.findIndex(item => item.type === 'group')
            const curIndex = objects.findIndex(item => item.time === t.time && item.type !== 'group')
            if (groupMap) {
              if (curIndex - groupIndex === -1) {
                t.bringForward() &&
                  syncOtherSide &&
                  this.syncOtherSideImage(i, t => {
                    t && t.bringForward()
                  })
              }
              this.createGroupImgEntry(this.activeGroupInfo.type, groupMap)
            }
          }
          break
        case 12:
          t &&
          t.sendBackwards() && // 向下一层
            this.syncOtherSide &&
            syncOtherSide &&
            this.syncOtherSideImage(i, t => {
              t && t.sendBackwards()
            })
          if (t && group) {
            const groupObj = objects.find(item => item.type === 'group')
            const groupMap = objects.find(item => groupObj.time === item.time && item.type !== 'group')
            const groupIndex = objects.findIndex(item => item.type === 'group')
            const curIndex = objects.findIndex(item => item.time === t.time && item.type !== 'group')
            if (groupMap) {
              if (curIndex - groupIndex === 1 || curIndex - groupIndex === 2) {
                t.sendBackwards() && // 向下一层
                  this.syncOtherSide &&
                  syncOtherSide &&
                  this.syncOtherSideImage(i, t => {
                    t && t.sendBackwards()
                  })
              }
              this.createGroupImgEntry(this.activeGroupInfo.type, groupMap)
            }
          }
          break
        case 20:
          this.delLayer()
          break
        case 21:
          const {
            activePrintAreas: { width }
          } = this
          t.scale(width / t.width)
          t.set({
            left: 275,
            top: 275
          })
          this.setTipLevel(
            getActualSizeTip(
              t.height,
              t.width,
              t.scaleX,
              t.scaleY,
              this.onePxToRealWidth,
              this.printImgInfo.dpi,
              t.pxH,
              t.pxW
            )
          )
          break
        case 22:
          const {
            activePrintAreas: { height }
          } = this
          t.set({
            left: 275,
            top: 275
          })
          t.scale(height / t.height)
          this.setTipLevel(
            getActualSizeTip(
              t.height,
              t.width,
              t.scaleX,
              t.scaleY,
              this.onePxToRealWidth,
              this.printImgInfo.dpi,
              t.pxH,
              t.pxW
            )
          )
          break
      }
      this.activeFabric.renderAll()
      this.setRandom()
      saveHistory()
    },
    scaleWithAngleFix(view_id, t) {
      const { width, height } = this.print_areas.find(item => item.view_id === view_id)
      const angleChange = (2 * Math.PI) / 360
      const x1 = Math.abs(Math.cos(t.angle * angleChange)) * width
      const x2 = Math.abs(Math.sin(t.angle * angleChange)) * width
      const scale = height / width
      const x3 = scale * x1
      const x4 = scale * x2
      const tHeight = t.height
      const tWidth = t.width
      const scaleWidth = (x1 + x4) / tWidth
      const scaleHeight = (x2 + x3) / tHeight
      t.set('originX', 'center')
      t.set('originY', 'center')
      t.set('scaleX', scaleWidth).setCoords()
      t.set('scaleY', scaleHeight).setCoords()
      t.set('left', 275).setCoords()
      t.set('top', 275).setCoords()
    },
    scaleSingleWithAngleFix(view_id, t) {
      const { width, height } = this.print_areas.find(item => item.view_id === view_id)
      console.log(width, height, 'width,height')
      console.log(t, 't')
      const angleChange = (2 * Math.PI) / 360
      console.log(angleChange, 'angleChange')
      const tHeight = t.height
      const tWidth = t.width
      if (tHeight >= tWidth) {
        const x1 = Math.abs(Math.cos(t.angle * angleChange)) * width
        const x2 = Math.abs(Math.sin(t.angle * angleChange)) * height
        return (x1 + x2) / tWidth
      } else {
        const x1 = Math.abs(Math.cos(t.angle * angleChange)) * height
        const x2 = Math.abs(Math.sin(t.angle * angleChange)) * width
        // console.log(x1 + x2, 'x1x2')
        console.log(x2, 'x2')
        console.log(x1, 'x1')
        return (x1 + x2) / tHeight
      }
    },
    copyLayer(index) {
      // 复制图层
      const forClone = this.activeFabric.getActiveObject()
      if (!forClone) {
        return
      }
      forClone.clone(cloned => {
        cloned.left += 20
        cloned.top += 20
        cloned.material_code = forClone.material_code
        cloned.vision_type = forClone.vision_type
        cloned.vision_oss_file_id = forClone.vision_oss_file_id
        this.activeFabric.add(cloned)
        this.setRandom()
      })
    },
    delLayer() {
      const activeImg = this.activeFabric.getActiveObject()
      if (!activeImg) {
        return
      }
      this.activeFabric.remove(activeImg)
      this.activeFabric.renderAll()
      this.setCanvasType('')
    },
    inputValueFn() {
      console.log('inputValue ====', this.inputValue)
      this.inputValue = parseInt(`${this.inputValue}`)
      console.log('inputValue ====2', this.inputValue)
      if (!this.inputValue) {
        this.inputValue = 0
      }
      if (+this.inputValue > 180) {
        this.inputValue = 180
      } else if (+this.inputValue < -180) {
        this.inputValue = -180
      }
      this.inputValue = +this.inputValue
      this.sliderValue = this.inputValue
      this.rotateResult(this.sliderValue)
    },
    setInputValue(n) {
      if (n > 0) {
        if (this.inputValue < 180) {
          this.inputValue++
        }
      } else {
        if (this.inputValue > -180) {
          this.inputValue--
        }
      }
      this.sliderValue = this.inputValue
      this.rotateResult(this.sliderValue)
    },
    sliderValueFn() {
      console.log('sliderValue===', this.sliderValue)
      this.inputValue = this.sliderValue
      this.rotateResult(this.sliderValue)
    },
    rotateFn(n) {
      const { activeFabric } = this
      const t = activeFabric.getActiveObject()
      if (!t) {
        return
      }
      const num = +this.inputValue + n
      console.log('num===', num)
      if (num > 180) {
        this.inputValue = this.sliderValue = num - 360
      } else if (num < -180) {
        this.inputValue = this.sliderValue = 360 + num
      } else {
        this.inputValue = this.sliderValue = num
      }
      this.rotateResult(this.sliderValue)
    },
    setSliderValue(num) {
      if (num > 180) {
        this.inputValue = this.sliderValue = num - 360
      } else if (num < -180) {
        this.inputValue = this.sliderValue = 360 + num
      } else {
        this.inputValue = this.sliderValue = num
      }
    },
    rotateResult(angle) {
      const { activeFabric } = this
      const t = activeFabric.getActiveObject()
      t.rotate(angle).setCoords()
      const objects = activeFabric.getObjects()
      const group = objects.find(item => item.type === 'group')
      if (t && group && group.time === t.time) {
        group.set('angle', angle).setCoords()
      }
      this.activeFabric.renderAll()
      this.setRandom()
    },
    handleMenuClick() {},
    copyProduct(record) {
      this.setCopyProductId(record.id)
      this.$emit('design', record.basic_product_id)
      // const { fabricList } = this
      // getProductDesignInfo({ id: record.id }).then(res => {
      //   const { product_design } = res.data
      //   const product_designJson = JSON.parse(product_design)
      //   product_designJson.forEach(designJson => {
      //     const { view_id, design_params } = designJson
      //     const { canObj } = fabricList.find(item => item.view_id === view_id)
      //     canObj.loadFromJSON(design_params, () => {
      //       canObj.renderAll()
      //     })
      //   })
      // })
      // // this.$emit('design', record.basic_product_id)
      // getProductDesignInfo({ id: record.id }).then(res => {
      //   const { product_design, print_areas, show_images_design, bottom_templates, sizes, colors } = res.data
      //   this.SET_SLIDER_INDEX(0)
      //   this.SET_BASIC_PRODUCT_ID(record.basic_product_id)
      //   const tipLevelsInfo = {}
      //   this.SET_ACTIVE_DESIGN(1)
      //   this.SET_ACTIVE_FABRIC_LIST_GRUOP(
      //     JSON.parse(product_design).map((item, index) => {
      //       tipLevelsInfo[index + 1] = item.design_params.tip_level
      //       return {
      //         canObj: item.design_params,
      //         index,
      //         view_id: item.view_id
      //       }
      //     })
      //   )
      //   console.log(tipLevelsInfo)
      //   this.SET_INITIAL_COLOR(colors[0].id)
      //   this.SET_PRINT_AREAS(print_areas)
      //   this.SET_PRINT_IMG_INFO(res.data)
      //   this.SET_ALL_BOTTOM_IMAGES_TEMPLATE(bottom_templates)
      //   this.SET_ALL_SHOW_IMAGES_DESIGN(show_images_design)
      //   this.SET_INITIAL_SIZE(sizes[0].id)
      //   const gruopInfo = {}
      //   for (let j = 0; j < print_areas.length; j++) {
      //     gruopInfo[j + 1] = {
      //       code: '',
      //       type: 0,
      //       paddingX: 0,
      //       paddingY: 0
      //     }
      //   }
      //   this.SET_INIT_TIP_LEVEL(tipLevelsInfo)
      //   this.SET_INITIAL_GROUP_INFO(gruopInfo)
      // })
    },
    regainFn() {
      const _this = this
      this.$confirm({
        title: 'Tips',
        content: 'Are you sure to restore the default shortcut keys?',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk() {
          setUserHotKeys({ hotKeys: [] }).then(res => {
            _this.isEdit = false
            getUserHotKeys().then(res => {
              _this.setHotKeys(res.data.hotKeys || [])
              _this.$parent.hotkeys.unbind()
              _this.$parent.bindShortcut()
            })
          })
        }
      })
    },
    getValue(e, value) {
      e.preventDefault()
      // value.enName
      if (e.keyCode === 16 || e.keyCode === 17 || e.keyCode === 18) {
        this.groupKey = e.keyCode
      } else {
        if (this.groupKey) {
          value.enName = `${keyCodeData[this.groupKey]} + ${keyCodeData[e.keyCode > 123 ? '999' : e.keyCode]}`
        } else {
          value.enName = `${keyCodeData[e.keyCode > 123 ? '999' : e.keyCode]}`
        }
      }
    },
    keyupFn(e) {
      if (e.keyCode === 16 || e.keyCode === 17 || e.keyCode === 18) {
        this.groupKey = ''
      }
      this.isTrue = false
      this.enName = ''
      const arr = []

      this.hotKeys.forEach(item => {
        if (arr.indexOf(item.enName) === -1) {
          arr.push(item.enName)
        } else {
          this.enName = item.enName
          this.isTrue = true
        }
      })
      if (this.isTrue) {
        this.$message.error(`The shortcut key conflicts with save "(${this.enName})", please reset it`, 2)
      }
    },
    focusFn(item) {
      this.currKey = { ...item }
      item.enName = ''
      this.groupKey = ''
    },
    blurFn(item) {
      if (!item.enName) {
        item.enName = this.currKey.enName
      }
    },
    editSave() {
      if (this.isTrue) {
        this.$message.error(`The shortcut key conflicts with save "(${this.enName})", please reset it`, 2)
        return
      }
      setUserHotKeys({ hotKeys: this.hotKeys }).then(res => {
        this.$parent.hotkeys.unbind()
        this.$parent.bindShortcut()
        this.isEdit = false
      })
    },
    editCancel() {
      this.isEdit = false
      getUserHotKeys().then(res => {
        this.setHotKeys(res.data.hotKeys || [])
      })
    },
    showBig(flag) {
      console.log(flag)
    },
    saveHistoryFu() {
      saveHistory()
    },
    async addShop() {
      const msg = await this.passed(() => this.save(1))
      if (msg.length) {
        return
      }
      this.save(1)
    },
    turnRight() {
      this.left = 0
    },
    isTansparent(base64, height, width) {
      const img = new Image()
      img.src = base64
      return new Promise(resolve => {
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          // console.log(ctx.getImageData(0, 0, height, width))
          const imageData = ctx.getImageData(0, 0, width, height)
          const { height: h, width: w, data } = imageData
          resolve(!this.hasTransparent(data, h, w))
        }
      })
    },

    async hasNoPixel(canObj, i, flag) {
      // const { left, top, width, height } = this.print_areas[i]
      const left = (this.print_areas[i].left * canObj.width) / 550
      const top = (this.print_areas[i].top * canObj.height) / 550
      const width = (this.print_areas[i].width * canObj.width) / 550
      const height = (this.print_areas[i].height * canObj.height) / 550
      const base64 = canObj.toDataURL({ left, top, width, height, multiplier: 0.1 })
      const isTansparent = await this.isTansparent(base64, height * 0.1, width * 0.1)
      isTansparent &&
        flag.push({ view_id: i + 1, msg: ' material is not fully covered,the product will be left blank' })
    },
    // 判断四个角是否是透明
    hasTransparent(data, height, width) {
      return (
        data.slice(0, 4).reduce((pre, next) => pre + next, 0) &&
        data.slice(4 * (width - 1), 4 * width).reduce((pre, next) => pre + next, 0) &&
        data.slice(4 * width * (height - 1), 4 * width * (height - 1) + 4).reduce((pre, next) => pre + next, 0) &&
        data.slice(4 * height * width - 4, 4 * height * width).reduce((pre, next) => pre + next, 0)
      )
    },
    async passed(callBack) {
      const flag = []
      const { fabricList } = this
      console.log(fabricList)
      for (let i = 0; i < fabricList.length; i++) {
        const { canObj } = fabricList[i]
        if (canObj.isEmpty()) {
          flag.push({ view_id: i + 1, msg: 'No material' })
          // continue
        }
        console.log('tipLevels====', this.tipLevels)
        if (this.tipLevels[i + 1]) {
          flag.push({ view_id: i + 1, msg: 'insufficient pixels, may cause printing blurring' })
          // continue
        }
        await this.hasNoPixel(canObj, i, flag)
      }
      if (flag.length) {
        // const content = flag.map(item => (
        //   <p style={{ color: 'red' }}>
        //     面{item.view_id}
        //     {item.msg}
        //   </p>
        // ))
        const confirmTime = this.$ls.get('confirmTime') || 0
        const date = new Date()
        const time = date.getTime()
        if (time - +confirmTime >= 86400000) {
          const _this = this
          this.$confirm({
            title: 'Tips',
            width: 500,
            content: () => {
              return (
                <div style="position: relative;">
                  {this.sortClass(flag).map((item, fIndex) => (
                    <p style={{ color: '333' }}>
                      <span style="margin-right: 6px;">{fIndex + 1}.</span>
                      {item.data.map((it, i) => (
                        <span>
                          Side {it.view_id}
                          {i < item.data.length - 1 ? '、' : ''}
                        </span>
                      ))}
                      <span style="color: #ff0000;">{item.msg}</span>
                    </p>
                  ))}
                  <span style="position: absolute;bottom: -60px;left: -30px;">
                    <a-checkbox checked={this.isBlack} onChange={this.isBlackFn}>
                      No more prompts in one day
                    </a-checkbox>
                  </span>
                </div>
              )
            },
            okText: 'Continue',
            cancelText: 'Redesign',
            onOk() {
              callBack()
              if (_this.isBlack) {
                _this.$ls.set('confirmTime', time)
              }
            }
          })
        } else {
          callBack()
        }
      }
      return flag
    },
    isBlackFn() {
      this.isBlack = !this.isBlack
    },
    async saveConfirm() {
      const msg = await this.passed(() => this.save())
      if (msg.length) {
        return
      }
      this.save()
    },
    async brandSaveConfirm() {
      const msg = await this.passed(() => this.brandSave())
      if (msg.length) {
        return
      }
      this.brandSave()
    },
    brandSave() {
      const { brand } = this.$refs
      brand.visible = true
    },
    brandBachSave(obj) {
      const { fabricList } = this
      const fabrics = fabricList.map((item, index) => {
        const design_params = item.canObj.toJSON([
          'material_code',
          'oss_file_id',
          'material_id',
          'style',
          'time',
          'pxH',
          'pxW',
          'tipLevel',
          'vision_type',
          'vision_oss_file_id',
          'groupType',
          'uuid'
        ])
        design_params.tip_level = this.tipLevels[item.view_id]
        return {
          view_id: item.view_id,
          design_params: design_params
        }
      })
      const data = {
        color_id: this.initialColor,
        size_id: this.initialSize,
        view_id: this.activeDesign,
        basic_product_id: this.basic_product_id,
        product_design: JSON.stringify(fabrics),
        width: 1000
      }
      saveDesign(data).then(res => {
        console.log('res===', res)
        addBrand({ product_id: res.data.id, brand_group_id: obj.brand_group_id }).then(res => {
          this.successNum = 5
        })
        setMasterImgColor({ id: res.data.id, color_id: this.initialColor }).then(res => {})
      })
    },
    sortClass(sortData) {
      const groupBy = (array, f) => {
        const groups = {}
        array.forEach(o => {
          const group = JSON.stringify(f(o))
          groups[group] = groups[group] || []
          groups[group].push(o)
        })
        return Object.keys(groups).map(group => {
          return groups[group]
        })
      }
      const sorted = groupBy(sortData, item => {
        return item.msg
      }).map(item => {
        return {
          data: item,
          msg: item[0].msg
        }
      })
      console.log('sorted===', sorted)
      return sorted
    },
    save(n) {
      console.log('do Save')
      const { fabricList } = this
      const fabrics = fabricList.map((item, index) => {
        const design_params = item.canObj.toJSON([
          'material_code',
          'oss_file_id',
          'material_id',
          'style',
          'time',
          'pxH',
          'pxW',
          'tipLevel',
          'vision_type',
          'vision_oss_file_id',
          'groupType',
          'uuid'
        ])
        design_params.tip_level = this.tipLevels[item.view_id]
        return {
          view_id: item.view_id,
          design_params: design_params
        }
      })
      const data = {
        color_id: this.initialColor,
        size_id: this.initialSize,
        view_id: this.activeDesign,
        basic_product_id: this.basic_product_id,
        product_design: JSON.stringify(fabrics),
        width: 1000
      }
      saveDesign(data).then(res => {
        console.log('res===', res)

        this.setSyncOtherSide(this.printImgInfo.is_merge_design === 1)
        if (this.configData.saveButText === '关联产品') {
          // this.setVisible(false)
          // this.setRelateInfo(res.data.id)
          this.$emit('change', res.data.id)
        }
        if (n === 1) {
          // const obj = {
          //   product_id: res.data.id,
          //   size_id: this.initialSize,
          //   color_id: this.initialColor,
          //   num: 1
          // }
          // addCartItem(obj).then(res => {
          //   this.getCartData()
          // })
          const { joinCar } = this.$refs
          const obj = res.data || {}
          joinCar.detail = obj
          joinCar.colorsList = obj.color_ids ? obj.color_ids.split(',') : []
          joinCar.joinCar = true
        } else if (n === 2) {
          this.visible_publish = true
          this.publish_id = res.data.id
        } else {
          // const { nameEdit } = this.$refs
          // nameEdit.product = res.data
          // nameEdit.visible = true
        }
        setMasterImgColor({ id: res.data.id, color_id: this.initialColor }).then(res => {
          if (!n && this.configData.saveButText !== '关联产品') {
            this.confirm_visible = 1
            this.countNum = 5
            setTimeout(() => {
              this.confirm_visible = 0
            }, 5000)
          }
        })
        if (this.info.is_keep_design_material === 2) {
          this.resetFabricList()
          this.setRandom()
          this.setCanvasType('')
        }
        // this.resetFabricList()
        // this.setRandom()
      })
    },
    turnLeft() {
      const { width } = this.$refs.imgBar.getBoundingClientRect()
      const offset = width - 480
      this.left = -offset
    },

    changSlideIndex(index) {
      this.$refs.slide.changeIndex(index)
    },
    async publishConfirm() {
      const msg = await this.passed(() => this.save(2))
      if (msg.length) {
        return
      }
      this.save(2)
    },
    ok() {
      const { storeListContent } = this.$refs
      if (!storeListContent.checked) {
        this.$message.error('Please select store')
        return
      }
      this.visible_publish = false
      // this.$router.push({
      //   name: 'publish',
      //   params: {
      //     store_id: storeListContent.checked,
      //     product_id: this.publish_id,
      //     tag: 'add',
      //     platform: storeListContent.platform
      //   }
      // })
      this.$ls.set('publishParams', {
        store_id: storeListContent.checked,
        product_id: this.publish_id,
        id: 0,
        isCreated: true,
        platform: storeListContent.platform
      })
      this.$router.push('/personal_center/productPublish')
    },
    showConfirmFn() {
      this.confirm_visible = 2
      this.countNum = 5
      setTimeout(() => {
        this.confirm_visible = 0
      }, 5000)
    }
  },
  mounted() {
    this.visiable = true
    getMaskLayer().then(res => {
      this.masks = res.data
    })
    getMaterialVision().then(res => {
      console.log('res=====22=====', res)
      this.designStyleData = res.data
      console.log('designStyleData=====', this.designStyleData)
    })
    getUserStore({ auth_status: 1, group_by: 'platform' }).then(res => {
      this.storeList = res.data
    })
  }
}
</script>

<style lang="less" scoped>
.shortcutKey {
  padding: 10px;
  width: 210px;
  box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.35);
  position: absolute;
  z-index: 999;
  background: white;
  top: -100%;
  right: 0;

  .title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
    > span {
      font-size: 14px;
      color: #666;
      .editBtn {
        // margin-left: 12px;
        color: #4c9be0;
        cursor: pointer;
      }
    }
  }

  .contentList {
    &.edit {
      padding-bottom: 30px;
    }
    .contentItem {
      display: flex;
      justify-content: space-between;
      > span {
        font-size: 14px;
        color: #333333;
        font-weight: bold;
      }
    }
    .handWrap {
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 6px 12px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #fff;
      z-index: 9;
      > span {
        color: #4c9be0;
        cursor: pointer;

        button {
          margin-left: 6px;
        }
      }
    }
  }
}
.rightWrap {
  width: 300px;
  position: relative;
  .topBar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    img,
    i {
      &:hover {
        cursor: pointer;
      }
    }
    > div {
      height: 50px;
      display: flex;
      align-items: center;
      &:hover {
        cursor: pointer;
      }

      i {
        margin-right: 4px;
      }
      span {
        font-size: 16px;
        font-weight: bold;
        color: #4c9be0;
      }
    }

    .activeDiv {
      border-bottom: 2px solid #4c9be0;
    }
    .barItem {
      position: relative;
      .recordBg {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 98;
      }
      .recordWrap {
        // display: none;
        visibility: hidden;
        position: absolute;
        top: 100%;
        left: 50%;
        width: 350px;
        padding: 20px;
        margin-left: -175px;
        background: #fff;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        z-index: 99;
        &.hover {
          // display: block;
          visibility: visible;
        }
      }
      .rdTop {
        display: flex;
        justify-content: space-between;
        span {
          font-size: 12px;
          color: #666;
        }
      }
      .rdBody {
        margin: 0 -10px;
        .rdItem {
          position: relative;
          float: left;
          width: 90px;
          height: 90px;
          margin: 10px 10px 0 10px;
          background: #000;
          h5 {
            visibility: hidden;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            margin: 0;
            font-size: 14px;
            color: #fff;
            background: rgba(0, 0, 0, 0.5);
            text-align: center;
          }
          &:hover {
            h5 {
              visibility: visible;
            }
          }
        }
      }
    }
  }
  .bottomWrap {
    padding: 20px;
    padding-top: 0;
    .bottomBut {
      margin-top: 8px;
      padding-bottom: 13px;
      display: flex;
      justify-content: space-around;
    }
    .selectPrice {
      position: relative;
      .price {
        padding-left: 20px;
        font-size: 48px;
        color: #de0000;
        font-weight: bolder;
        vertical-align: middle;
      }
    }
  }
  .imgShowWrap {
    padding-bottom: 20px;
    position: relative;
    height: 469px;
    width: 469px;
    .bigger {
      position: absolute;
      right: 10px;
      top: 20px;
      z-index: 999;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .imgWrap {
    position: relative;
    width: 100%;
    height: 96px;
    overflow: hidden;
    .imgBar {
      white-space: nowrap;
      height: 96px;
      padding-right: 10px;
      .imgItem {
        height: 96px;
        width: 96px;
        margin-right: 14px;
        border-radius: 5px;
        overflow: hidden;
        display: inline-block;
        border: 1px solid #959595;
        &:hover {
          border: 1px solid #4b9bdf;
        }
      }
    }
  }
  .rightMain {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 12px 10px;
    background: #fff;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    .rightBox {
      flex: 1;
      overflow: auto;
      display: flex;
      flex-direction: column;
      .nullP {
        padding-top: 40px;
        text-align: center;
      }
      .replaceImgBtn {
        height: 40px;
        border-radius: 4px;
        line-height: 40px;
        font-size: 16px;
        color: #666;
        background: #f6f7f9;
        cursor: pointer;
        text-align: center;
      }
      .operateBar {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        &.bg {
          height: 42px;
          border-radius: 4px;
          padding: 0 20px;
          background: #f6f7f9;
        }
        .operateItem {
          width: 50px;
          height: 50px;
          background: #f6f7f9;
          border-radius: 4px;
          cursor: pointer;
          &.w130 {
            width: 130px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            .iconBox {
              display: inline-block;
              margin-right: 4px;
              width: 20px;
              height: 20px;
              vertical-align: -6px;
              &.txIcon {
                background: url('../../../assets/design/right_17.png') center center no-repeat;
              }
              &.ppIcon {
                background: url('../../../assets/design/right_9.png') center center no-repeat;
              }
              &.fgIcon {
                background: url('../../../assets/design/right_10.png') center center no-repeat;
              }
              &.zzIcon {
                background: url('../../../assets/design/right_11.png') center center no-repeat;
              }
            }
            &.hover:hover {
              color: #fff;
              background: #3699ff;
              .txIcon {
                background: url('../../../assets/design/right_17_hr.png') center center no-repeat;
              }
              .ppIcon {
                background: url('../../../assets/design/right_9_hr.png') center center no-repeat;
              }
              .fgIcon {
                background: url('../../../assets/design/right_10_hr.png') center center no-repeat;
              }
              .zzIcon {
                background: url('../../../assets/design/right_11_hr.png') center center no-repeat;
              }
            }
          }
          &.htcIcon {
            background: url('../../../assets/design/right_1.png') center center no-repeat #f6f7f9;
          }
          &.wtcIcon {
            background: url('../../../assets/design/right_2.png') center center no-repeat #f6f7f9;
          }
          &.tcIcon {
            background: url('../../../assets/design/right_3.png') center center no-repeat #f6f7f9;
          }
          &.syIcon {
            background: url('../../../assets/design/right_4.png') center center no-repeat #f6f7f9;
          }
          &.xzIcon {
            background: url('../../../assets/design/right_5.png') center center no-repeat #f6f7f9;
          }
          &.jzIcon {
            background: url('../../../assets/design/right_6.png') center center no-repeat #f6f7f9;
          }
          &.xfzIcon {
            background: url('../../../assets/design/right_7.png') center center no-repeat #f6f7f9;
          }
          &.yfzIcon {
            background: url('../../../assets/design/right_8.png') center center no-repeat #f6f7f9;
          }
        }
        .iconBox {
          width: 22px;
          height: 22px;
          cursor: pointer;
          &.sfIcon {
            background: url('../../../assets/design/right_12.png') center center no-repeat;
          }
          &.fzIcon {
            background: url('../../../assets/design/right_13.png') center center no-repeat;
          }
          &.upIcon {
            background: url('../../../assets/design/right_14.png') center center no-repeat;
          }
          &.downIcon {
            background: url('../../../assets/design/right_15.png') center center no-repeat;
          }
          &.deleteIcon {
            background: url('../../../assets/design/right_16.png') center center no-repeat;
          }
          &:hover {
            &.sfIcon {
              background: url('../../../assets/design/right_12.png') center center no-repeat;
            }
            &.fzIcon {
              background: url('../../../assets/design/right_13.png') center center no-repeat;
            }
            &.upIcon {
              background: url('../../../assets/design/right_14.png') center center no-repeat;
            }
            &.downIcon {
              background: url('../../../assets/design/right_15.png') center center no-repeat;
            }
            &.deleteIcon {
              background: url('../../../assets/design/right_16.png') center center no-repeat;
            }
          }
        }
        .inputBox {
          position: relative;
          .caretBox {
            position: absolute;
            top: 0;
            right: 0;
            width: 24px;
            height: 100%;
            z-index: 1;
          }
          .caretBtn {
            position: absolute;
            right: 4px;
            font-size: 16px;
            color: #666;
            cursor: pointer;
            z-index: 1;
            &:hover {
              color: #3699ff;
            }
            &.up {
              top: 2px;
            }
            &.down {
              bottom: 2px;
            }
          }
        }
      }
    }
    .imgShowWrap {
      width: 280px;
      height: 280px;
      overflow: hidden;
      border: 1px solid #eee;
      border-radius: 4px;
    }
  }
}

.leftCurrent {
  position: absolute;
  left: 0;
  top: 36px;
  z-index: 999;
  &:hover {
    cursor: pointer;
  }
}
.rightCurrent {
  position: absolute;
  right: 0;
  top: 36px;
  z-index: 999;
  &:hover {
    cursor: pointer;
  }
}
</style>
